export const AdminAssessmentPaymentConstants = {
    paginationHeaderConstants: {
        numbering: '번호',
        hospitalName: '병원명',
        patientName: '환자명',
        userTestingNo: '접수번호',
        assessmentCode: '검사코드',
        retailPrice: '정가',
        supplyPrice: '공급가',
        paymentDateTime: '일시',
        isTest: '변경',
    },
    pageCommonConstants: {
        title: '개별 검사 정산',
    },
    searchFilterList: ['전체', '병원', '이름'],
};